import { Grid } from "antd";
import { useForm } from "antd/es/form/Form";
import { FC, useEffect } from "react";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useHotelsListingContext } from "../../context/HotelsListingContext";
import { useDebounceFn } from "src/hooks/useDebounce";
import { generateInitialFilterValues } from "../../utils";
import { Range } from "src/components/Filters";
import { track } from "@amplitude/analytics-browser";
import FiltersBarWeb from "./layouts/FiltersBar.web";
import FiltersBarMob from "./layouts/FiltersBar.mob";

const FiltersBarComponent = withConditionalComponent(FiltersBarWeb, FiltersBarMob);

const FiltersBar: FC<{ dataGroups: any }> = ({ dataGroups }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [form] = useForm();
  const { filters, setFilters, isFetching, dataCount } = useHotelsListingContext();

  const debouncedUpdateFilters = useDebounceFn(setFilters, 200);

  const initialValues = generateInitialFilterValues(dataGroups);

  const handleChange = (changedValues: Record<string, unknown>) => {
    const allValues = form.getFieldsValue(true);
    track("Filters Updated", { ...changedValues });
    debouncedUpdateFilters(allValues);
  };

  const handleReset = () => {
    form.resetFields();
    track("Filters Reset");
    debouncedUpdateFilters(initialValues);
  };

  useEffect(() => {
    if (dataGroups) {
      form.setFieldsValue(initialValues);
      debouncedUpdateFilters(initialValues);
    }
  }, [dataGroups]);

  useEffect(() => {
    form.setFieldsValue(filters);
  }, [filters]);

  const filterComponents = {
    range: {
      Component: Range,
    },
  };

  return (
    <FiltersBarComponent
      trigger={isLargeScreen}
      props={{
        form,
        initialValues,
        handleChange,
        handleReset,
        dataCount,
        isFetching,
        dataGroups,
        filterComponents,
      }}
    />
  );
};

export default FiltersBar;
